const state = {
    timezoneSchedule: localStorage.getItem('timezoneSchedule') || 'Manila',
    timezonesSchedule: [
        //UTC -11
        { zone: 'UTC -11:00', location: 'Midway', region: 'Pacific' },
        { zone: 'UTC -11:00', location: 'Niue', region: 'Pacific' },
        { zone: 'UTC -11:00', location: 'Pago Pago', region: 'Pacific' },
        //UTC -10
        { zone: 'UTC -10:00', location: 'Honolulu', region: 'Pacific' },
        { zone: 'UTC -10:00', location: 'Rarotonga', region: 'Pacific' },
        { zone: 'UTC -10:00', location: 'Tahiti', region: 'Pacific' },
        //UTC -9:30
        { zone: 'UTC -09:30', location: 'Marquesas', region: 'Pacific' },
        //UTC -9
        { zone: 'UTC -09:00', location: 'Adak', region: 'America' },
        { zone: 'UTC -09:00', location: 'Gambier', region: 'Pacific' },
        //UTC -8
        { zone: 'UTC -08:00', location: 'Anchorage', region: 'America' },
        { zone: 'UTC -08:00', location: 'Juneau', region: 'America' },
        { zone: 'UTC -08:00', location: 'Metlakatla', region: 'America' },
        { zone: 'UTC -08:00', location: 'Nome', region: 'America' },
        { zone: 'UTC -08:00', location: 'Sitka', region: 'America' },
        { zone: 'UTC -08:00', location: 'Yakutat', region: 'America' },
        { zone: 'UTC -08:00', location: 'Pitcairn', region: 'Pacific' },
        //UTC -7
        { zone: 'UTC -07:00', location: 'Creston', region: 'America' },
        { zone: 'UTC -07:00', location: 'Dawson', region: 'America' },
        { zone: 'UTC -07:00', location: 'Dawson Creek', region: 'America' },
        { zone: 'UTC -07:00', location: 'Fort Nelson', region: 'America' },
        { zone: 'UTC -07:00', location: 'Hermosillo', region: 'America' },
        { zone: 'UTC -07:00', location: 'Los Angeles', region: 'America' },
        { zone: 'UTC -07:00', location: 'Phoenix', region: 'America' },
        { zone: 'UTC -07:00', location: 'Tijuana', region: 'America' },
        { zone: 'UTC -07:00', location: 'Vancouver', region: 'America' },
        { zone: 'UTC -07:00', location: 'Whitehorse', region: 'America' },
        //UTC -6
        { zone: 'UTC -06:00', location: 'Belize', region: 'America' },
        { zone: 'UTC -06:00', location: 'Boise', region: 'America' },
        { zone: 'UTC -06:00', location: 'Cambridge Bay', region: 'America' },
        { zone: 'UTC -06:00', location: 'Chihuahua', region: 'America' },
        { zone: 'UTC -06:00', location: 'Costa Rica', region: 'America' },
        { zone: 'UTC -06:00', location: 'Denver', region: 'America' },
        { zone: 'UTC -06:00', location: 'Edmonton', region: 'America' },
        { zone: 'UTC -06:00', location: 'El Salvador', region: 'America' },
        { zone: 'UTC -06:00', location: 'Guatemala', region: 'America' },
        { zone: 'UTC -06:00', location: 'Inuvik', region: 'America' },
        { zone: 'UTC -06:00', location: 'Managua', region: 'America' },
        { zone: 'UTC -06:00', location: 'Mazatlan', region: 'America' },
        { zone: 'UTC -06:00', location: 'Ojinaga', region: 'America' },
        { zone: 'UTC -06:00', location: 'Regina', region: 'America' },
        { zone: 'UTC -06:00', location: 'Swift Current', region: 'America' },
        { zone: 'UTC -06:00', location: 'Tegucigalpa', region: 'America' },
        { zone: 'UTC -06:00', location: 'Yellowknife', region: 'America' },
        { zone: 'UTC -06:00', location: 'Galapagos', region: 'Pacific' },
        //UTC -5
        { zone: 'UTC -05:00', location: 'Atikokan', region: 'America' },
        { zone: 'UTC -05:00', location: 'Bahia Banderas', region: 'America' },
        { zone: 'UTC -05:00', location: 'Beulah', region: 'America' },
        { zone: 'UTC -05:00', location: 'Bogota', region: 'America' },
        { zone: 'UTC -05:00', location: 'Cancun', region: 'America' },
        { zone: 'UTC -05:00', location: 'Cayman', region: 'America' },
        { zone: 'UTC -05:00', location: 'Center', region: 'America' },
        { zone: 'UTC -05:00', location: 'Chicago', region: 'America' },
        { zone: 'UTC -05:00', location: 'Eirunepe', region: 'America' },
        { zone: 'UTC -05:00', location: 'Guayaquil', region: 'America' },
        { zone: 'UTC -05:00', location: 'Jamaica', region: 'America' },
        { zone: 'UTC -05:00', location: 'Knox', region: 'America' },
        { zone: 'UTC -05:00', location: 'Jamaica', region: 'America' },
        { zone: 'UTC -05:00', location: 'Lima', region: 'America' },
        { zone: 'UTC -05:00', location: 'Matamoros', region: 'America' },
        { zone: 'UTC -05:00', location: 'Menominee', region: 'America' },
        { zone: 'UTC -05:00', location: 'Merida', region: 'America' },
        { zone: 'UTC -05:00', location: 'Mexico City', region: 'America' },
        { zone: 'UTC -05:00', location: 'Monterrey', region: 'America' },
        { zone: 'UTC -05:00', location: 'New Salem', region: 'America' },
        { zone: 'UTC -05:00', location: 'Panama', region: 'America' },
        { zone: 'UTC -05:00', location: 'Rainy River', region: 'America' },
        { zone: 'UTC -05:00', location: 'Rankin Inlet', region: 'America' },
        { zone: 'UTC -05:00', location: 'Resolute', region: 'America' },
        { zone: 'UTC -05:00', location: 'Rio Branco', region: 'America' },
        { zone: 'UTC -05:00', location: 'Tell City', region: 'America' },
        { zone: 'UTC -05:00', location: 'Winnipeg', region: 'America' },
        { zone: 'UTC -05:00', location: 'Easter', region: 'Pacific' },
        //UTC -4
        { zone: 'UTC -04:00', location: 'Anguilla', region: 'America' },
        { zone: 'UTC -04:00', location: 'Antigua', region: 'America' },
        { zone: 'UTC -04:00', location: 'Aruba', region: 'America' },
        { zone: 'UTC -04:00', location: 'Asuncion', region: 'America' },
        { zone: 'UTC -04:00', location: 'Barbados', region: 'America' },
        { zone: 'UTC -04:00', location: 'Blanc-Sablon', region: 'America' },
        { zone: 'UTC -04:00', location: 'Boa Vista', region: 'America' },
        { zone: 'UTC -04:00', location: 'Campo Grande', region: 'America' },
        { zone: 'UTC -04:00', location: 'Caracas', region: 'America' },
        { zone: 'UTC -04:00', location: 'Cuiaba', region: 'America' },
        { zone: 'UTC -04:00', location: 'Curacao', region: 'America' },
        { zone: 'UTC -04:00', location: 'Detroit', region: 'America' },
        { zone: 'UTC -04:00', location: 'Dominica', region: 'America' },
        { zone: 'UTC -04:00', location: 'Grand Turk', region: 'America' },
        { zone: 'UTC -04:00', location: 'Grenada', region: 'America' },
        { zone: 'UTC -04:00', location: 'Guadeloupe', region: 'America' },
        { zone: 'UTC -04:00', location: 'Guyana', region: 'America' },
        { zone: 'UTC -04:00', location: 'Havana', region: 'America' },
        { zone: 'UTC -04:00', location: 'Indianapolis', region: 'America' },
        { zone: 'UTC -04:00', location: 'Iqaluit', region: 'America' },
        { zone: 'UTC -04:00', location: 'Kralendijk', region: 'America' },
        { zone: 'UTC -04:00', location: 'La Paz', region: 'America' },
        { zone: 'UTC -04:00', location: 'Louisville', region: 'America' },
        { zone: 'UTC -04:00', location: 'Lower Princes', region: 'America' },
        { zone: 'UTC -04:00', location: 'Manaus', region: 'America' },
        { zone: 'UTC -04:00', location: 'Marengo', region: 'America' },
        { zone: 'UTC -04:00', location: 'Marigot', region: 'America' },
        { zone: 'UTC -04:00', location: 'Martinique', region: 'America' },
        { zone: 'UTC -04:00', location: 'Monticello', region: 'America' },
        { zone: 'UTC -04:00', location: 'Montserrat', region: 'America' },
        { zone: 'UTC -04:00', location: 'Nassau', region: 'America' },
        { zone: 'UTC -04:00', location: 'New York', region: 'America' },
        { zone: 'UTC -04:00', location: 'Nipigon', region: 'America' },
        { zone: 'UTC -04:00', location: 'Pangnirtung', region: 'America' },
        { zone: 'UTC -04:00', location: 'Petersburg', region: 'America' },
        { zone: 'UTC -04:00', location: 'Port of Spain', region: 'America' },
        { zone: 'UTC -04:00', location: 'Port-au-Prince', region: 'America' },
        { zone: 'UTC -04:00', location: 'Porto Velho', region: 'America' },
        { zone: 'UTC -04:00', location: 'Puerto Rico', region: 'America' },
        { zone: 'UTC -04:00', location: 'Santo Domingo', region: 'America' },
        { zone: 'UTC -04:00', location: 'St Barthelemy', region: 'America' },
        { zone: 'UTC -04:00', location: 'St Kitts', region: 'America' },
        { zone: 'UTC -04:00', location: 'St Lucia', region: 'America' },
        { zone: 'UTC -04:00', location: 'St Thomas', region: 'America' },
        { zone: 'UTC -04:00', location: 'St Vincent', region: 'America' },
        { zone: 'UTC -04:00', location: 'Thunder Bay', region: 'America' },
        { zone: 'UTC -04:00', location: 'Tortola', region: 'America' },
        { zone: 'UTC -04:00', location: 'Toronto', region: 'America' },
        { zone: 'UTC -04:00', location: 'Vevay', region: 'America' },
        { zone: 'UTC -04:00', location: 'Vincennes', region: 'America' },
        { zone: 'UTC -04:00', location: 'Winamac', region: 'America' },
        //UTC -3
        { zone: 'UTC -03:00', location: 'Araguaina', region: 'America' },
        { zone: 'UTC -03:00', location: 'Bahia', region: 'America' },
        { zone: 'UTC -03:00', location: 'Belem', region: 'America' },
        { zone: 'UTC -03:00', location: 'Buenos Aires', region: 'America' },
        { zone: 'UTC -03:00', location: 'Catamarca', region: 'America' },
        { zone: 'UTC -03:00', location: 'Cayenne', region: 'America' },
        { zone: 'UTC -03:00', location: 'Cordoba', region: 'America' },
        { zone: 'UTC -03:00', location: 'Fortaleza', region: 'America' },
        { zone: 'UTC -03:00', location: 'Glace Bay', region: 'America' },
        { zone: 'UTC -03:00', location: 'Goose Bay', region: 'America' },
        { zone: 'UTC -03:00', location: 'Halifax', region: 'America' },
        { zone: 'UTC -03:00', location: 'Jujuy', region: 'America' },
        { zone: 'UTC -03:00', location: 'La Rioja', region: 'America' },
        { zone: 'UTC -03:00', location: 'Maceio', region: 'America' },
        { zone: 'UTC -03:00', location: 'Mendoza', region: 'America' },
        { zone: 'UTC -03:00', location: 'Montevideo', region: 'America' },
        { zone: 'UTC -03:00', location: 'Punta Arenas', region: 'America' },
        { zone: 'UTC -03:00', location: 'Recife', region: 'America' },
        { zone: 'UTC -03:00', location: 'Rio Gallegos', region: 'America' },
        { zone: 'UTC -03:00', location: 'Salta', region: 'America' },
        { zone: 'UTC -03:00', location: 'San Juan', region: 'America' },
        { zone: 'UTC -03:00', location: 'San Luis', region: 'America' },
        { zone: 'UTC -03:00', location: 'Santarem', region: 'America' },
        { zone: 'UTC -03:00', location: 'Santiago', region: 'America' },
        { zone: 'UTC -03:00', location: 'São Paulo', region: 'America' },
        { zone: 'UTC -03:00', location: 'Tucuman', region: 'America' },
        { zone: 'UTC -03:00', location: 'Thule', region: 'America' },
        { zone: 'UTC -03:00', location: 'Ushuaia', region: 'America' },
        { zone: 'UTC -03:00', location: 'Palmer', region: 'Antarctica' },
        { zone: 'UTC -03:00', location: 'Rothera', region: 'Antarctica' },
        { zone: 'UTC -03:00', location: 'Bermuda', region: 'Atlantic' },
        { zone: 'UTC -03:00', location: 'Stanley', region: 'Atlantic' },
        //UTC -2:30
        { zone: 'UTC -02:30', location: 'St Johns', region: 'America' },
        //UTC -2
        { zone: 'UTC -02:00', location: 'Godthab', region: 'America' },
        { zone: 'UTC -02:00', location: 'Miquelon', region: 'America' },
        { zone: 'UTC -02:00', location: 'Noronha', region: 'America' },
        { zone: 'UTC -02:00', location: 'South Georgia', region: 'Atlantic' },
        //UTC -1
        { zone: 'UTC -01:00', location: 'Cape Verde', region: 'Atlantic' },
        //UTC +0
        { zone: 'UTC +00:00', location: 'Abidjan', region: 'Africa' },
        { zone: 'UTC +00:00', location: 'Accra', region: 'Africa' },
        { zone: 'UTC +00:00', location: 'Bamako', region: 'Africa' },
        { zone: 'UTC +00:00', location: 'Banjul', region: 'Africa' },
        { zone: 'UTC +00:00', location: 'Conakry', region: 'Africa' },
        { zone: 'UTC +00:00', location: 'Dakar', region: 'Africa' },
        { zone: 'UTC +00:00', location: 'Freetown', region: 'Africa' },
        { zone: 'UTC +00:00', location: 'Lome', region: 'Africa' },
        { zone: 'UTC +00:00', location: 'Monrovia', region: 'Africa' },
        { zone: 'UTC +00:00', location: 'Nouakchott', region: 'Africa' },
        { zone: 'UTC +00:00', location: 'Ouagadougou', region: 'Africa' },
        { zone: 'UTC +00:00', location: 'Danmarkshavn', region: 'America' },
        { zone: 'UTC +00:00', location: 'Scoresbysund', region: 'America' },
        { zone: 'UTC +00:00', location: 'Azores', region: 'Atlantic' },
        { zone: 'UTC +00:00', location: 'Reykjavik', region: 'Atlantic' },
        { zone: 'UTC +00:00', location: 'St Helena', region: 'Atlantic' },
        //UTC +1
        { zone: 'UTC +01:00', location: 'Algiers', region: 'Africa' },
        { zone: 'UTC +01:00', location: 'Bangui', region: 'Africa' },
        { zone: 'UTC +01:00', location: 'Brazzaville', region: 'Africa' },
        { zone: 'UTC +01:00', location: 'Casablanca', region: 'Africa' },
        { zone: 'UTC +01:00', location: 'Douala', region: 'Africa' },
        { zone: 'UTC +01:00', location: 'El Aaiun', region: 'Africa' },
        { zone: 'UTC +01:00', location: 'Lagos', region: 'Africa' },
        { zone: 'UTC +01:00', location: 'Libreville', region: 'Africa' },
        { zone: 'UTC +01:00', location: 'Luanda', region: 'Africa' },
        { zone: 'UTC +01:00', location: 'Kinshasa', region: 'Africa' },
        { zone: 'UTC +01:00', location: 'Malabo', region: 'Africa' },
        { zone: 'UTC +01:00', location: 'Ndjamena', region: 'Africa' },
        { zone: 'UTC +01:00', location: 'Niamey', region: 'Africa' },
        { zone: 'UTC +01:00', location: 'Porto-Novo', region: 'Africa' },
        { zone: 'UTC +01:00', location: 'Sao Tome', region: 'Africa' },
        { zone: 'UTC +01:00', location: 'Tunis', region: 'Africa' },
        { zone: 'UTC +01:00', location: 'Canary', region: 'Atlantic' },
        { zone: 'UTC +01:00', location: 'Faroe', region: 'Atlantic' },
        { zone: 'UTC +01:00', location: 'Madeira', region: 'Atlantic' },
        { zone: 'UTC +01:00', location: 'Dublin', region: 'Europe' },
        { zone: 'UTC +01:00', location: 'Guernsey', region: 'Europe' },
        { zone: 'UTC +01:00', location: 'Isle Of Man', region: 'Europe' },
        { zone: 'UTC +01:00', location: 'Jersey', region: 'Europe' },
        { zone: 'UTC +01:00', location: 'Lisbon', region: 'Europe' },
        { zone: 'UTC +01:00', location: 'London', region: 'Europe' },
        //UTC +2
        { zone: 'UTC +02:00', location: 'Blantyre', region: 'Africa' },
        { zone: 'UTC +02:00', location: 'Bujumbura', region: 'Africa' },
        { zone: 'UTC +02:00', location: 'Cairo', region: 'Africa' },
        { zone: 'UTC +02:00', location: 'Ceuta', region: 'Africa' },
        { zone: 'UTC +02:00', location: 'Gaborone', region: 'Africa' },
        { zone: 'UTC +02:00', location: 'Harare', region: 'Africa' },
        { zone: 'UTC +02:00', location: 'Johannesburg', region: 'Africa' },
        { zone: 'UTC +02:00', location: 'Khartoum', region: 'Africa' },
        { zone: 'UTC +02:00', location: 'Kigali', region: 'Africa' },
        { zone: 'UTC +02:00', location: 'Lubumbashi', region: 'Africa' },
        { zone: 'UTC +02:00', location: 'Lusaka', region: 'Africa' },
        { zone: 'UTC +02:00', location: 'Maputo', region: 'Africa' },
        { zone: 'UTC +02:00', location: 'Maseru', region: 'Africa' },
        { zone: 'UTC +02:00', location: 'Mbabane', region: 'Africa' },
        { zone: 'UTC +02:00', location: 'Tripoli', region: 'Africa' },
        { zone: 'UTC +02:00', location: 'Windhoeck', region: 'Africa' },
        { zone: 'UTC +02:00', location: 'Amsterdam', region: 'Europe' },
        { zone: 'UTC +02:00', location: 'Andorra', region: 'Europe' },
        { zone: 'UTC +02:00', location: 'Belgrade', region: 'Europe' },
        { zone: 'UTC +02:00', location: 'Berlin', region: 'Europe' },
        { zone: 'UTC +02:00', location: 'Bratislava', region: 'Europe' },
        { zone: 'UTC +02:00', location: 'Brussels', region: 'Europe' },
        { zone: 'UTC +02:00', location: 'Budapest', region: 'Europe' },
        { zone: 'UTC +02:00', location: 'Busingen', region: 'Europe' },
        { zone: 'UTC +02:00', location: 'Copenhagen', region: 'Europe' },
        { zone: 'UTC +02:00', location: 'Gibraltar', region: 'Europe' },
        { zone: 'UTC +02:00', location: 'Kaliningrad', region: 'Europe' },
        { zone: 'UTC +02:00', location: 'Ljubljana', region: 'Europe' },
        { zone: 'UTC +02:00', location: 'Luxembourg', region: 'Europe' },
        { zone: 'UTC +02:00', location: 'Madrid', region: 'Europe' },
        { zone: 'UTC +02:00', location: 'Malta', region: 'Europe' },
        { zone: 'UTC +02:00', location: 'Monaco', region: 'Europe' },
        { zone: 'UTC +02:00', location: 'Oslo', region: 'Europe' },
        { zone: 'UTC +02:00', location: 'Paris', region: 'Europe' },
        { zone: 'UTC +02:00', location: 'Podgorica', region: 'Europe' },
        { zone: 'UTC +02:00', location: 'Prague', region: 'Europe' },
        { zone: 'UTC +02:00', location: 'Rome', region: 'Europe' },
        { zone: 'UTC +02:00', location: 'San Marino', region: 'Europe' },
        { zone: 'UTC +02:00', location: 'San Marino', region: 'Europe' },
        { zone: 'UTC +02:00', location: 'Sarajevo', region: 'Europe' },
        { zone: 'UTC +02:00', location: 'San Marino', region: 'Europe' },
        { zone: 'UTC +02:00', location: 'Skopje', region: 'Europe' },
        { zone: 'UTC +02:00', location: 'Stockholm', region: 'Europe' },
        { zone: 'UTC +02:00', location: 'Tirane', region: 'Europe' },
        { zone: 'UTC +02:00', location: 'Vaduz', region: 'Europe' },
        { zone: 'UTC +02:00', location: 'Vaduz', region: 'Europe' },
        { zone: 'UTC +02:00', location: 'Vatican', region: 'Europe' },
        { zone: 'UTC +02:00', location: 'Vienna', region: 'Europe' },
        { zone: 'UTC +02:00', location: 'Warsaw', region: 'Europe' },
        { zone: 'UTC +02:00', location: 'Zagreb', region: 'Europe' },
        { zone: 'UTC +02:00', location: 'Zurich', region: 'Europe' },
        //UTC +3
        { zone: 'UTC +03:00', location: 'Addis Ababa', region: 'Africa' },
        { zone: 'UTC +03:00', location: 'Asmara', region: 'Africa' },
        { zone: 'UTC +03:00', location: 'Dar es Salaam', region: 'Africa' },
        { zone: 'UTC +03:00', location: 'Djibouti', region: 'Africa' },
        { zone: 'UTC +03:00', location: 'Juba', region: 'Africa' },
        { zone: 'UTC +03:00', location: 'Kampala', region: 'Africa' },
        { zone: 'UTC +03:00', location: 'Mogadishu', region: 'Africa' },
        { zone: 'UTC +03:00', location: 'Nairobi', region: 'Africa' },
        { zone: 'UTC +03:00', location: 'Syowa', region: 'Antarctica' },
        { zone: 'UTC +03:00', location: 'Aden', region: 'Asia' },
        { zone: 'UTC +03:00', location: 'Amman', region: 'Asia' },
        { zone: 'UTC +03:00', location: 'Baghdad', region: 'Asia' },
        { zone: 'UTC +03:00', location: 'Bahrain', region: 'Asia' },
        { zone: 'UTC +03:00', location: 'Beirut', region: 'Asia' },
        { zone: 'UTC +03:00', location: 'Damascus', region: 'Asia' },
        { zone: 'UTC +03:00', location: 'Famagusta', region: 'Asia' },
        { zone: 'UTC +03:00', location: 'Gaza', region: 'Asia' },
        { zone: 'UTC +03:00', location: 'Hebron', region: 'Asia' },
        { zone: 'UTC +03:00', location: 'Jerusalem', region: 'Asia' },
        { zone: 'UTC +03:00', location: 'Kuwait', region: 'Asia' },
        { zone: 'UTC +03:00', location: 'Nicosia', region: 'Asia' },
        { zone: 'UTC +03:00', location: 'Qatar', region: 'Asia' },
        { zone: 'UTC +03:00', location: 'Riyadh', region: 'Asia' },
        { zone: 'UTC +03:00', location: 'Athens', region: 'Europe' },
        { zone: 'UTC +03:00', location: 'Bucharest', region: 'Europe' },
        { zone: 'UTC +03:00', location: 'Chisinau', region: 'Europe' },
        { zone: 'UTC +03:00', location: 'Helsinki', region: 'Europe' },
        { zone: 'UTC +03:00', location: 'Istanbul', region: 'Europe' },
        { zone: 'UTC +03:00', location: 'Kiev', region: 'Europe' },
        { zone: 'UTC +03:00', location: 'Kirov', region: 'Europe' },
        { zone: 'UTC +03:00', location: 'Mariehamn', region: 'Europe' },
        { zone: 'UTC +03:00', location: 'Minsk', region: 'Europe' },
        { zone: 'UTC +03:00', location: 'Moscow', region: 'Europe' },
        { zone: 'UTC +03:00', location: 'Riga', region: 'Europe' },
        { zone: 'UTC +03:00', location: 'Simferopol', region: 'Europe' },
        { zone: 'UTC +03:00', location: 'Sofia', region: 'Europe' },
        { zone: 'UTC +03:00', location: 'Tallinn', region: 'Europe' },
        { zone: 'UTC +03:00', location: 'Uzhgorod', region: 'Europe' },
        { zone: 'UTC +03:00', location: 'Vilnius', region: 'Europe' },
        { zone: 'UTC +03:00', location: 'Volgograd', region: 'Europe' },
        { zone: 'UTC +03:00', location: 'Zaporozhye', region: 'Europe' },
        { zone: 'UTC +03:00', location: 'Antananarivo', region: 'Indian' },
        { zone: 'UTC +03:00', location: 'Comoro', region: 'Indian' },
        { zone: 'UTC +03:00', location: 'Mayotte', region: 'Indian' },
        //UTC +4
        { zone: 'UTC +04:00', location: 'Baku', region: 'Asia' },
        { zone: 'UTC +04:00', location: 'Dubai', region: 'Asia' },
        { zone: 'UTC +04:00', location: 'Muscat', region: 'Asia' },
        { zone: 'UTC +04:00', location: 'Tbilisi', region: 'Asia' },
        { zone: 'UTC +04:00', location: 'Yerevan', region: 'Asia' },
        { zone: 'UTC +04:00', location: 'Astrakhan', region: 'Europe' },
        { zone: 'UTC +04:00', location: 'Samara', region: 'Europe' },
        { zone: 'UTC +04:00', location: 'Ulyanovsk', region: 'Europe' },
        { zone: 'UTC +04:00', location: 'Mahe', region: 'Indian' },
        { zone: 'UTC +04:00', location: 'Mauritius', region: 'Indian' },
        { zone: 'UTC +04:00', location: 'Reunion', region: 'Indian' },
        //UTC +4:30
        { zone: 'UTC +04:30', location: 'Kabul', region: 'Asia' },
        { zone: 'UTC +04:30', location: 'Tehran', region: 'Asia' },
        //UTC +5
        { zone: 'UTC +05:00', location: 'Mawson', region: 'Antarctica' },
        { zone: 'UTC +05:00', location: 'Aqtau', region: 'Asia' },
        { zone: 'UTC +05:00', location: 'Aqtobe', region: 'Asia' },
        { zone: 'UTC +05:00', location: 'Ashgabat', region: 'Asia' },
        { zone: 'UTC +05:00', location: 'Atyrau', region: 'Asia' },
        { zone: 'UTC +05:00', location: 'Dushanbe', region: 'Asia' },
        { zone: 'UTC +05:00', location: 'Karachi', region: 'Asia' },
        { zone: 'UTC +05:00', location: 'Oral', region: 'Asia' },
        { zone: 'UTC +05:00', location: 'Samarkand', region: 'Asia' },
        { zone: 'UTC +05:00', location: 'Tashkent', region: 'Asia' },
        { zone: 'UTC +05:00', location: 'Yekaterinburg', region: 'Asia' },
        { zone: 'UTC +05:00', location: 'Kerguelen', region: 'Indian' },
        { zone: 'UTC +05:00', location: 'Maldives', region: 'Indian' },
        //UTC +5:30
        { zone: 'UTC +05:30', location: 'Colombo', region: 'Asia' },
        { zone: 'UTC +05:30', location: 'Kolkata', region: 'Asia' },
        //UTC +5:45
        { zone: 'UTC +05:45', location: 'Kathmandu', region: 'Asia' },
        //UTC +6
        { zone: 'UTC +06:00', location: 'Vostok', region: 'Antarctica' },
        { zone: 'UTC +06:00', location: 'Almaty', region: 'Asia' },
        { zone: 'UTC +06:00', location: 'Bishkek', region: 'Asia' },
        { zone: 'UTC +06:00', location: 'Dhaka', region: 'Asia' },
        { zone: 'UTC +06:00', location: 'Omsk', region: 'Asia' },
        { zone: 'UTC +06:00', location: 'Qyzylorda', region: 'Asia' },
        { zone: 'UTC +06:00', location: 'Thimphu', region: 'Asia' },
        { zone: 'UTC +06:00', location: 'Urumqi', region: 'Asia' },
        { zone: 'UTC +06:00', location: 'Chagos', region: 'Indian' },
        //UTC +6:30
        { zone: 'UTC +06:30', location: 'Yangon', region: 'Asia' },
        { zone: 'UTC +06:30', location: 'Cocos', region: 'Indian' },
        //UTC +7
        { zone: 'UTC +07:00', location: 'Davis', region: 'Antarctica' },
        { zone: 'UTC +07:00', location: 'Bangkok', region: 'Asia' },
        { zone: 'UTC +07:00', location: 'Barnaul', region: 'Asia' },
        { zone: 'UTC +07:00', location: 'Ho Chi Minh', region: 'Asia' },
        { zone: 'UTC +07:00', location: 'Hovd', region: 'Asia' },
        { zone: 'UTC +07:00', location: 'Jakarta', region: 'Asia' },
        { zone: 'UTC +07:00', location: 'Krasnoyarsk', region: 'Asia' },
        { zone: 'UTC +07:00', location: 'Novokuznetsk', region: 'Asia' },
        { zone: 'UTC +07:00', location: 'Novosibirsk', region: 'Asia' },
        { zone: 'UTC +07:00', location: 'Phnom Penh', region: 'Asia' },
        { zone: 'UTC +07:00', location: 'Pontianak', region: 'Asia' },
        { zone: 'UTC +07:00', location: 'Tomsk', region: 'Asia' },
        { zone: 'UTC +07:00', location: 'Vientiane', region: 'Asia' },
        { zone: 'UTC +07:00', location: 'Christmas', region: 'Indian' },
        //UTC +8
        { zone: 'UTC +08:00', location: 'Casey', region: 'Antarctica' },
        { zone: 'UTC +08:00', location: 'Brunei', region: 'Asia' },
        { zone: 'UTC +08:00', location: 'Choibalsan', region: 'Asia' },
        { zone: 'UTC +08:00', location: 'Hong Kong', region: 'Asia' },
        { zone: 'UTC +08:00', location: 'Irkutsk', region: 'Asia' },
        { zone: 'UTC +08:00', location: 'Kuala Lumpur', region: 'Asia' },
        { zone: 'UTC +08:00', location: 'Kuching', region: 'Asia' },
        { zone: 'UTC +08:00', location: 'Macau', region: 'Asia' },
        { zone: 'UTC +08:00', location: 'Manila', region: 'Asia' },
        { zone: 'UTC +08:00', location: 'Makassar', region: 'Asia' },
        { zone: 'UTC +08:00', location: 'Shanghai', region: 'Asia' },
        { zone: 'UTC +08:00', location: 'Singapore', region: 'Asia' },
        { zone: 'UTC +08:00', location: 'Taipei', region: 'Asia' },
        { zone: 'UTC +08:00', location: 'Ulaanbaatar', region: 'Asia' },
        { zone: 'UTC +08:00', location: 'Perth', region: 'Australia' },
        //UTC +8:30
        { zone: 'UTC +08:30', location: 'Pyongyang', region: 'Asia' },
        //UTC +8:45
        { zone: 'UTC +08:45', location: 'Eucia', region: 'Australia' },
        //UTC +9
        { zone: 'UTC +09:00', location: 'Chita', region: 'Asia' },
        { zone: 'UTC +09:00', location: 'Dili', region: 'Asia' },
        { zone: 'UTC +09:00', location: 'Jayapura', region: 'Asia' },
        { zone: 'UTC +09:00', location: 'Khandyga', region: 'Asia' },
        { zone: 'UTC +09:00', location: 'Seoul', region: 'Asia' },
        { zone: 'UTC +09:00', location: 'Tokyo', region: 'Asia' },
        { zone: 'UTC +09:00', location: 'Yakutsk', region: 'Asia' },
        { zone: 'UTC +09:00', location: 'Palau', region: 'Pacific' },
        //UTC +9:30
        { zone: 'UTC +09:30', location: 'Adelaide', region: 'Australia' },
        { zone: 'UTC +09:30', location: 'Broken Hill', region: 'Australia' },
        { zone: 'UTC +09:30', location: 'Darwin', region: 'Australia' },
        //UTC +10
        { zone: 'UTC +10:00', location: 'Dumont d\'Urville', region: 'Antarctica' },
        { zone: 'UTC +10:00', location: 'Ust-Nera', region: 'Asia' },
        { zone: 'UTC +10:00', location: 'Vladivostok', region: 'Asia' },
        { zone: 'UTC +10:00', location: 'Brisbane', region: 'Australia' },
        { zone: 'UTC +10:00', location: 'Currie', region: 'Australia' },
        { zone: 'UTC +10:00', location: 'Hobart', region: 'Australia' },
        { zone: 'UTC +10:00', location: 'Lindeman', region: 'Australia' },
        { zone: 'UTC +10:00', location: 'Melbourne', region: 'Australia' },
        { zone: 'UTC +10:00', location: 'Sydney', region: 'Australia' },
        { zone: 'UTC +10:00', location: 'Chuuk', region: 'Pacific' },
        { zone: 'UTC +10:00', location: 'Guam', region: 'Pacific' },
        { zone: 'UTC +10:00', location: 'Port Moresby', region: 'Pacific' },
        { zone: 'UTC +10:00', location: 'Saipan', region: 'Pacific' },
        //UTC +10:30
        { zone: 'UTC +10:30', location: 'Lord Howe', region: 'Australia' },
        //UTC +11
        { zone: 'UTC +11:00', location: 'Macquarie', region: 'Antarctica' },
        { zone: 'UTC +11:00', location: 'Magadan', region: 'Asia' },
        { zone: 'UTC +11:00', location: 'Sakhalin', region: 'Asia' },
        { zone: 'UTC +11:00', location: 'Srednekolymsk', region: 'Asia' },
        { zone: 'UTC +11:00', location: 'Bougainville', region: 'Pacific' },
        { zone: 'UTC +11:00', location: 'Efate', region: 'Pacific' },
        { zone: 'UTC +11:00', location: 'Guadalcanal', region: 'Pacific' },
        { zone: 'UTC +11:00', location: 'Kosrae', region: 'Pacific' },
        { zone: 'UTC +11:00', location: 'Norfolk', region: 'Pacific' },
        { zone: 'UTC +11:00', location: 'Noumea', region: 'Pacific' },
        { zone: 'UTC +11:00', location: 'Pohnpei', region: 'Pacific' },
        //UTC +12
        { zone: 'UTC +12:00', location: 'McMurdo', region: 'Antarctica' },
        { zone: 'UTC +12:00', location: 'Anadyr', region: 'Asia' },
        { zone: 'UTC +12:00', location: 'Kamchatka', region: 'Asia' },
        { zone: 'UTC +12:00', location: 'Auckland', region: 'Pacific' },
        { zone: 'UTC +12:00', location: 'Fiji', region: 'Pacific' },
        { zone: 'UTC +12:00', location: 'Funafuti', region: 'Pacific' },
        { zone: 'UTC +12:00', location: 'Majuro', region: 'Pacific' },
        { zone: 'UTC +12:00', location: 'Nauru', region: 'Pacific' },
        { zone: 'UTC +12:00', location: 'Pkwajalein', region: 'Pacific' },
        { zone: 'UTC +12:00', location: 'Tarawa', region: 'Pacific' },
        { zone: 'UTC +12:00', location: 'Wake', region: 'Pacific' },
        { zone: 'UTC +12:00', location: 'Wallis', region: 'Pacific' },
        //UTC +12:45
        { zone: 'UTC +12:45', location: 'Chatham', region: 'Pacific' },
        //UTC +13
        { zone: 'UTC +13:00', location: 'Apia', region: 'Pacific' },
        { zone: 'UTC +13:00', location: 'Enderbury', region: 'Pacific' },
        { zone: 'UTC +13:00', location: 'Fakaofo', region: 'Pacific' },
        { zone: 'UTC +13:00', location: 'Tongatapu', region: 'Pacific' },
        //UTC +14
        { zone: 'UTC +14:00', location: 'Kiritimati', region: 'Pacific' },
    ]
};

const getters = {
    timezonesSchedule: state => state.timezonesSchedule,
    timezoneSchedule: state => state.timezoneSchedule
};

const mutations = {
    setTimezoneSchedule(state, timezoneSchedule) {
        state.timezoneSchedule = timezoneSchedule;
        localStorage.setItem('timezoneSchedule', timezoneSchedule);
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations
};
